import axiosInstance from "./axios";

export const subscriptionProfileFetcher = async () =>
  axiosInstance
    .get("/clients-management/client-subscription-profile-handler")
    .then((response) => response.data);
